import React from 'react';
import DNABox from "../../layout/DNABox/DNABox";
import { useButtonGroup } from './useButtonGroup';
export const DNAButtonGroup = (props) => {
    const { children, appearance = 'row', ...rest } = props;
    const processedChildren = useButtonGroup({ children, appearance });
    return (<DNABox appearance={appearance} {...rest}>
      {processedChildren}
    </DNABox>);
};
export default DNAButtonGroup;
//# sourceMappingURL=DNAButtonGroup.js.map